/**
 * Hide carousel progress bars when their track isn't scrollable
 * (same condition as floating arrows / no overflow).
 */
(function () {
  var SELECTOR = 'progress-bar.progress-bar--limit-width[track-scroll-target]';
  var scheduled = false;
  var observed = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var resizeObserver =
    typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(function () {
          schedule();
        })
      : null;

  function isScrollable(el) {
    return !!(el && el.scrollWidth > el.clientWidth + 1);
  }

  function syncBar(bar) {
    var id = bar.getAttribute('track-scroll-target');
    if (!id) return;

    var target = document.getElementById(id);
    var scrollable = isScrollable(target);
    bar.hidden = !scrollable;
    bar.setAttribute('aria-hidden', scrollable ? 'false' : 'true');

    if (target && resizeObserver && observed && !observed.has(target)) {
      observed.add(target);
      resizeObserver.observe(target);
    }
  }

  function syncAll() {
    document.querySelectorAll(SELECTOR).forEach(syncBar);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }
})();
